/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteTimelineConstraintTimeWindowDtoModel, RouteTimelineConstraintTimeWindowDtoModelType } from "./RouteTimelineConstraintTimeWindowDtoModel"
import { RouteTimelineConstraintTimeWindowDtoModelSelector } from "./RouteTimelineConstraintTimeWindowDtoModel.base"
import { RootStoreType } from "./index"


/**
 * RouteTimelineConstraintDtoBase
 * auto generated base class for the model RouteTimelineConstraintDtoModel.
 */
export const RouteTimelineConstraintDtoModelBase = ModelBase
  .named('RouteTimelineConstraintDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineConstraintDto"), "RouteTimelineConstraintDto"),
    id: types.identifier,
    routeTimelineId: types.union(types.undefined, types.number),
    load: types.union(types.undefined, types.null, types.number),
    duration: types.union(types.undefined, types.null, types.number),
    address: types.union(types.undefined, types.null, types.string),
    originalAddress: types.union(types.undefined, types.null, types.string),
    tags: types.union(types.undefined, types.null, types.array(types.string)),
    latitude: types.union(types.undefined, types.number),
    longitude: types.union(types.undefined, types.number),
    timeWindows: types.union(types.undefined, types.null, types.array(types.late((): any => RouteTimelineConstraintTimeWindowDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTimelineConstraintDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeTimelineId() { return this.__attr(`routeTimelineId`) }
  get load() { return this.__attr(`load`) }
  get duration() { return this.__attr(`duration`) }
  get address() { return this.__attr(`address`) }
  get originalAddress() { return this.__attr(`originalAddress`) }
  get tags() { return this.__attr(`tags`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
  timeWindows(builder: string | RouteTimelineConstraintTimeWindowDtoModelSelector | ((selector: RouteTimelineConstraintTimeWindowDtoModelSelector) => RouteTimelineConstraintTimeWindowDtoModelSelector) | undefined) { return this.__child(`timeWindows`, RouteTimelineConstraintTimeWindowDtoModelSelector, builder) }
}
export function selectFromRouteTimelineConstraintDto() {
  return new RouteTimelineConstraintDtoModelSelector()
}

export const routeTimelineConstraintDtoModelPrimitives = selectFromRouteTimelineConstraintDto().routeTimelineId.load.duration.address.originalAddress.tags.latitude.longitude
